import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getFullVersion } from "util/Version";
import useProductName from "brand-customization/useProductName";
import useSystemDetails from "hooks/useSystemDetails";
import { fetchSystemJvm } from "hooks/useSystemStore";
const StandardFooter = () => {
  const productName = useProductName();
  const { data: jvm } = useQuery({ queryKey: ["system", "jvm"], queryFn: fetchSystemJvm });
  const system = useSystemDetails();
  return !(system && jvm) ? /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " ", getFullVersion()) : /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " ", system.version, " on ", system.hostname, " (", jvm.info, ")");
};
export default StandardFooter;
